'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isHtml = function isHtml(str) {
  return str.startsWith('<!DOCTYPE');
};

var splitToNewLines = function splitToNewLines(str) {
  var n = str.split('\n');
  if (!!n.length) return n;
  var r = str.split('\r');
  if (!!r.length) return r;
  var nr = str.split('\nr');
  if (!!nr.length) return nr;
  return [];
};

exports.default = function (rawMessage) {
  if (isHtml(rawMessage) && rawMessage.includes('exception_value')) return rawMessage.split('<pre class="exception_value">')[1].split('</pre>')[0];
  if (rawMessage.startsWith('Exception at') || splitToNewLines(rawMessage).length >= 2 && splitToNewLines(rawMessage)[0].includes('Error at')) return splitToNewLines(rawMessage)[1];
  console.error(rawMessage);
  return 'Unknown';
};